module.exports = __webpack_public_path__ + "static/media/shape-copy-13.8977040c.svg";